export const reducedClutterGoogleMapStyle = [
  // turn off all markers to reduce clutter, particularly from irrelevant businesses,
  // then turn park names back on to help people orient
  {
    "featureType": "poi",
    "elementType": "labels",
    "stylers": [{ "visibility": "off" }]
  },
  {
    "featureType": "poi.park",
    "elementType": "labels",
    "stylers": [{ "visibility": "on" }]
  },

  // make the map greyer so the parks etc. don't conflict with the choropleth colors
  {
    "featureType": "poi",
    "stylers": [{ "saturation": -90 }]
  },
  {
    "featureType": "landscape.natural",
    "stylers": [{ "saturation": -90 }]
  },
  {
    "featureType": "water",
    "stylers": [{ "saturation": -60 }]
  },
];
